// FETCH ALL PROPERTIES FROM AREA MASTER
export const FETCH_AREA_MASTER_REQUEST = 'FETCH_AREA_MASTER_REQUEST';
export const FETCH_AREA_MASTER_SUCCESS = 'FETCH_AREA_MASTER_SUCCESS';
export const FETCH_AREA_MASTER_FAILURE = 'FETCH_AREA_MASTER_FAILURE';

// CREATE PROPERTIES FOR AREA MASTER
export const CREATE_AREA_MASTER_REQUEST = 'CREATE_AREA_MASTER_REQUEST';
export const CREATE_AREA_MASTER_SUCCESS = 'CREATE_AREA_MASTER_SUCCESS';
export const CREATE_AREA_MASTER_FAILURE = 'CREATE_AREA_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_AREA_MASTER = 'CREATE_USER_FORM_AREA_MASTER';

//UPDATE USER FORM
export const UPDATE_USER_FORM_AREA_MASTER = 'UPDATE_USER_FORM_AREA_MASTER';

//GET COUNTRY, CITY, AREA, PINCODE FROM PROPERTY TABLE
export const USER_ADDRESS_INFO_REQUEST = 'USER_ADDRESS_INFO_REQUEST';
export const USER_ADDRESS_INFO_SUCCESS = 'USER_ADDRESS_INFO_SUCCESS';
export const USER_ADDRESS_INFO_FAILURE = 'USER_ADDRESS_INFO_FAILURE';

//GET STATE FROM STATE TABLE
export const USER_STATE_LIST_REQUEST = 'USER_STATE_LIST_REQUEST';
export const USER_STATE_LIST_SUCCESS = 'USER_STATE_LIST_SUCCESS';
export const USER_STATE_LIST_FAILURE = 'USER_STATE_LIST_FAILURE';

// UPDATE PROPERTIES FOR AREA MASTER
export const UPDATE_AREA_MASTER_REQUEST = 'UPDATE_AREA_MASTER_REQUEST';
export const UPDATE_AREA_MASTER_SUCCESS = 'UPDATE_AREA_MASTER_SUCCESS';
export const UPDATE_AREA_MASTER_FAILURE = 'UPDATE_AREA_MASTER_FAILURE';

// FETCH SINGLE AREA
export const FETCH_SINGLE_AREA_MASTER_REQUEST = 'FETCH_SINGLE_AREA_MASTER_REQUEST';
export const FETCH_SINGLE_AREA_MASTER_SUCCESS = 'FETCH_SINGLE_AREA_MASTER_SUCCESS';
export const FETCH_SINGLE_AREA_MASTER_FAILURE = 'FETCH_SINGLE_AREA_MASTER_FAILURE';

// DELETE PROPERTIES FOR AREA MASTER
export const DELETE_AREA_MASTER_REQUEST = 'DELETE_AREA_MASTER_REQUEST';
export const DELETE_AREA_MASTER_SUCCESS = 'DELETE_AREA_MASTER_SUCCESS';
export const DELETE_AREA_MASTER_FAILURE = 'DELETE_AREA_MASTER_FAILURE';

//RESET USER_ADDRESS_INFO
export const RESET_USER_ADDRESS_INFO = 'RESET_USER_ADDRESS_INFO';
